export {BaseBadge} from "./BaseBadge";
export type {BadgeVariant} from "./BaseBadge";
